import React from "react"

const BranchContext = React.createContext({})

export const BranchProvider = BranchContext.Provider
export const BranchConsumer = BranchContext.Consumer

export default BranchContext
